import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	align-content: center;
	justify-content: space-between;
`;

export const list = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-content: center;
	justify-content: center;
`;

export const item = styled.div`
	width: 100%;
`;

export const handle = styled.div<{
	$isDragging: boolean;
	$showBtnDrag: boolean;
}>`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	justify-content: center;
	cursor: ${(props) =>
		props.$showBtnDrag ? 'default' : props.$showBtnDrag ? 'grabbing' : 'grab'};
`;

export const icon = styled.div<{
	$isDragging: boolean;
	$colorSvg: string;
	$sizeIconDrag: string;
}>`
	cursor: ${(props) => (props.$isDragging ? 'grabbing' : 'grab')};
	> svg {
		font-size: ${(props) => props.$sizeIconDrag};
		color: ${(props) => props.$colorSvg};
	}
`;
